import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import classNames from 'classnames';
export default function TabPane(_ref) {
  var prefixCls = _ref.prefixCls,
    forceRender = _ref.forceRender,
    className = _ref.className,
    style = _ref.style,
    id = _ref.id,
    active = _ref.active,
    animated = _ref.animated,
    destroyInactiveTabPane = _ref.destroyInactiveTabPane,
    tabKey = _ref.tabKey,
    children = _ref.children;
  var _React$useState = React.useState(forceRender),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visited = _React$useState2[0],
    setVisited = _React$useState2[1];
  React.useEffect(function () {
    if (active) {
      setVisited(true);
    } else if (destroyInactiveTabPane) {
      setVisited(false);
    }
  }, [active, destroyInactiveTabPane]);
  var mergedStyle = {};
  if (!active) {
    if (animated) {
      mergedStyle.visibility = 'hidden';
      mergedStyle.height = 0;
      mergedStyle.overflowY = 'hidden';
    } else {
      mergedStyle.display = 'none';
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    id: id && "".concat(id, "-panel-").concat(tabKey),
    role: "tabpanel",
    tabIndex: active ? 0 : -1,
    "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
    "aria-hidden": !active,
    style: _objectSpread(_objectSpread({}, mergedStyle), style),
    className: classNames("".concat(prefixCls, "-tabpane"), active && "".concat(prefixCls, "-tabpane-active"), className)
  }, (active || visited || forceRender) && children);
}